import React, { useMemo, memo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { formatMessage } from "lib/globalize-util";
import { Table, TableHead, TableBody, TableRow, TableCell } from "@material-ui/core";
import { ColorInsights } from "models/insights/color-insights";

const useStyles = makeStyles({
    headerRow: {
        "& .MuiTableCell-head": {
            fontWeight: "bold",
        },
    },
    cell: {
        fontSize: "1.3rem",
        paddingLeft: 4,
        paddingRight: 4,
    },
    rankCellHeader: {
        width: "54px",
    },
    colorCellHeader: {
        width: "159px",
    },
    colorCell: {
        paddingLeft: "16px",
        maxWidth: "159px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
});

interface ColorInsightsTableProps {
    productColors: ColorInsights[];
}

const ColorInsightsTable = memo(({ productColors }: ColorInsightsTableProps) => {
    const classes = useStyles();

    const tableRows = useMemo(() => {
        return productColors.map((color) => (
            <TableRow key={color.rank}>
                <TableCell className={classes.cell} component="th" scope="row" align="center">
                    #{color.rank}
                </TableCell>
                <TableCell className={`${classes.cell} ${classes.colorCell}`} align="left">
                    {color.name}
                </TableCell>
            </TableRow>
        ));
    }, [productColors, classes.cell, classes.colorCell]);

    return (
        <Table>
            <TableHead>
                <TableRow className={classes.headerRow}>
                    <TableCell className={`${classes.cell} ${classes.rankCellHeader}`}>
                        {formatMessage("Rank")}
                    </TableCell>
                    <TableCell
                        className={`${classes.cell} ${classes.colorCellHeader} ${classes.colorCell}`}
                        align="left"
                    >
                        {formatMessage("Color")}
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>{tableRows}</TableBody>
        </Table>
    );
});

export default ColorInsightsTable;
